import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-purpl-table-video',
  templateUrl: './purpl-table-video.component.html',
  styleUrls: ['./purpl-table-video.component.scss'],
})
export class PurplTableVideoComponent implements OnInit {
  @Input() videoSrc?: string;

  constructor() {}

  ngOnInit(): void {}
}
